import React from 'react';
import logo from '../../images/logo.svg';
import './Footer.scss';

// Images
import facebook from '../../images/icon-facebook.svg';
import twitter from '../../images/icon-twitter.svg';
import pinterest from '../../images/icon-pinterest.svg';
import instagram from '../../images/icon-instagram.svg';

export default function Footer() {
  return (
    <footer className='footer'>
      <img
        src={logo}
        alt='Shortly logo'
        className='footer__logo footer__block-1'
      />
      <div className='footer__block-2 footer__text-block'>
        <p>Features</p>
        <ul>
          <li>Link Shortening</li>
          <li>Branded Links</li>
          <li>Analytics</li>
        </ul>
      </div>
      <div className='footer__block-3 footer__text-block'>
        <p>Resources</p>
        <ul>
          <li>Blog</li>
          <li>Developers</li>
          <li>Support</li>
        </ul>
      </div>
      <div className='footer__block-4 footer__text-block'>
        <p>Company</p>
        <ul>
          <li>About</li>
          <li>Our Team</li>
          <li>Careers</li>
          <li>Contact</li>
        </ul>
      </div>
      <div className='footer__block-5 footer__social-logos'>
        <img src={facebook} alt='facebook logo' />
        <img src={twitter} alt='twitter logo' />
        <img src={pinterest} alt='pinterest logo' />
        <img src={instagram} alt='instagram logo' />
      </div>
    </footer>
  );
}
